import { useQuery, useQueryClient } from "@tanstack/react-query";
import { fetchLatestFilters, FetchLatestFiltersParams } from "PFCore/services/filters";
import { QueryOptions } from "PFTypes/request_options";
import { SavedFiltersV2 } from "PFTypes/saved_filters";

import { savedFiltersKeys } from "./query_keys";

export const useLatestFilters = (
  params: FetchLatestFiltersParams,
  { enabled, ...options }: QueryOptions<SavedFiltersV2 | null> = {}
) => {
  const queries = useQueryClient();
  return useQuery<SavedFiltersV2 | null>({
    queryKey: savedFiltersKeys.latestFilters(params),
    queryFn: () => fetchLatestFilters(params),
    enabled: enabled && !queries.isMutating({ mutationKey: savedFiltersKeys.latestFilters(params) }),
    retry: false,
    ...options
  });
};
